import { render, staticRenderFns } from "./ranksList.vue?vue&type=template&id=22eba6d3&scoped=true&"
import script from "./ranksList.vue?vue&type=script&lang=js&"
export * from "./ranksList.vue?vue&type=script&lang=js&"
import style0 from "./ranksList.vue?vue&type=style&index=0&id=22eba6d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eba6d3",
  null
  
)

export default component.exports